import React from "react";
import { useContext } from "react";
import { expertContext } from "../../../../context/expertcontext";
import { useState, useEffect } from "react";
import { getSheetInfo ,addSheet } from "../../../../services/kojaServices";
import Swal from "sweetalert2";
import Num2persian from "num2persian";
import { toast } from "react-hot-toast";
import Steps from "./Steps";
import { downloadUrl2 } from "../../../../confing/confing";


const FinalRegistration = ({ sheetId, item , info}) => {
  const {
    estate,
    attributes,
    attributes2,
    attributes3,
    totalPrice,
    areaInfo,
    imgName,
    description,
    setTab,
    tab
  } = useContext(expertContext);
  const [expert,setExpert] = useState({})

  useEffect(() => {

    const fetchData = async () => {
      // console.log(item);
      try {
        const { data } = await getSheetInfo(item.requestToken);
        // console.log(data.result.expert);
        let expert2 = {
          name: data.result.expert[0]?.name,
          agencyName: data.result.expert[0]?.agencyName,
          agencyTel: data.result.expert[0]?.agencyTel,
          stamp: `${downloadUrl2}${data.result.expert[0]?.stamp}`,
          agencyAddress : data.result.expert[0]?.agencyAddress
        };
        setExpert(expert2)
        // console.log(expert2)
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const previousStep = (values) => {
    if (tab > 1) {
      setTab(tab - 1);
    }
  };

  const sendData = async () => {
    Swal.fire({
        title: "لطفا منتظر بمانید",
        didOpen: () => {
          Swal.showLoading();
        },
      });
    const data = {
        ...estate,
        priceShow: {
          number: totalPrice.toLocaleString(),
          string: Num2persian(Math.round(totalPrice))
        },
        price: totalPrice,
        expert: { ...expert },
        user: {
          name: item.Ex_Owner.name,
        },
        date: Intl.DateTimeFormat("fa-IR").format(new Date()),
        requestToken: `${item.requestToken}`,
        areaInfo: { ...areaInfo },
        attributesArray: [
          ...attributes,
          ...attributes2,
          ...attributes3.aryy,
        { ...attributes3.attributes},
        ],
        description: description,
        sheetId: `E ${sheetId}`,
        crocki: imgName ? `${downloadUrl2}${imgName}` : "" ,
      };
      console.log(data);
   try{
      const {data : sheet} = await addSheet(data)
      console.log(sheet)
      Swal.fire({
        icon: 'success',
        title: `صورت کارشناسی با موفقیت ثبت شد`,
        showConfirmButton: false,
        timer: 2000
      })
      window.location.reload()
   }catch(err){
    console.log(err)
    Swal.close()
    Swal.fire({
      icon: 'error',
      title: `خطایی رخ داده است مجدد تلاش کنید`,
      showConfirmButton: false,
      timer: 2000
    }) 
  }
  };

  return (
    <div className="soratkarshenasi-form">
    <div>
  {/*
  <div className="mb-2 px-2 d-flex justify-content-between">
      <div className=" request-Previous-btn-box mt-2">
        <button
          className="btn request-Previous-btn "
          type="button"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
      </div>
    </div>
*/}

    <div>
    <Steps />
    <div className="mb-2 px-2 d-flex justify-content-between">
      <div className=" request-next-btn-box mt-2">
        <button type="button" className="btn request-next-btn" onClick={()=>{sendData()}}>
          ثبت
        </button>
      </div>
      <div className=" request-Previous-btn-box mt-2">
        <button
          className="btn request-Previous-btn "
          type="button"
          onClick={() => {
            previousStep();
          }}
        >
          قبلی
        </button>
      </div>
    </div>
  </div>
  </div>
    </div>
  );
};

export default FinalRegistration;
